import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	ModalBox,
	Button,
	FilterBoxStoryDate,
	FilterBoxStoryType,
	FilterBoxStoryFile,
	FilterBoxStoryCategory
} from 'Elements';
import { resetFilters, setCategory, setFilterMarkers } from 'Actions';
import styles from 'partials/modalbox/modal-filter.module.scss';

export const ModalBoxFilter = ({ size, onClose, isOpen }) => {
	const initialState = {
		filter_data: [],
		typeFilter: {
			is_section: null,
			is_verify: null
		},
		categoryFilter: [],
		filesFilter: {
			image: null,
			audio: null,
			video: null
		},
		dateRange: {
			from: null,
			to: null
		}
	};

	const dispatch = useDispatch();
	const stories = useSelector((state) => state.marker);
	const filters = useSelector((state) => state.fltr);
	const [, setState] = useState(initialState);

	const originData = stories.originList;
	const selectedFilters = filters.selected_filter;

	const getFilterData = useCallback(() => {
		const filter_data = [];

		// Loop trought every story
		originData.map((story) => {
			return filter_data.push({
				story_id: story.id,
				is_section: story.is_section,
				is_verify: story.is_verify,
				has_files: story.has_files,
				start_date: story.start_date,
				end_date: story.end_date,
				category: groupObjectBy(story.categories, 'title')
			});
		});

		return filter_data;
	}, [originData]);

	const groupObjectBy = (arrayOfObj, property) => {
		const uniqueArray = [];
		arrayOfObj.map((key) => {
			return uniqueArray.push(
				key[property]
				// isChecked: false
			);
		});
		return uniqueArray;
	};

	const createFilter = useCallback(() => {
		const filter_data = getFilterData();

		const unique_filter_data = [];
		filter_data.map((item) => {
			for (let arr of [item.category]) {
				unique_filter_data.push(...arr);
			}
		});
		const uniqueSet = [...new Set(unique_filter_data)];
		dispatch(setCategory(uniqueSet));
	}, [getFilterData, dispatch]);

	const getMaxDate = (
		arrayOfObjects,
		initialValue = arrayOfObjects[0]?.end_date
	) => {
		return arrayOfObjects.reduce((acc, cur) => {
			const date = cur.end_date;
			let maxVal = date >= acc ? date : acc;
			return maxVal;
		}, initialValue);
	};

	const getMinDate = (
		arrayOfObjects,
		initialValue = arrayOfObjects[0]?.start_date
	) => {
		return arrayOfObjects.reduce((acc, cur) => {
			const date = cur.start_date;
			let maxVal = date <= acc ? date : acc;
			return maxVal;
		}, initialValue);
	};

	const minDate = useMemo(() => getMinDate(originData), [originData]);

	const maxDate = useMemo(() => getMaxDate(originData), [originData]);

	const date_filter_list = useCallback(
		(selectedFilters) => {
			const filteredData = originData.filter((item) => {
				if (selectedFilters.from_date) {
					return (
						item.start_date >=
						(selectedFilters.from_date ?? minDate)
					);
				}
				if (selectedFilters.to_date) {
					return (
						item.end_date >= (selectedFilters.to_date ?? maxDate)
					);
				}
			});
			return filteredData.length ? filteredData : originData;
		},
		[originData, maxDate, minDate]
	);

	const type_filter_list = (prevFilter, selectedFilters) => {
		// console.log('selectedFilters: ', selectedFilters);
		const filtered_list = [];
		if (!selectedFilters.is_section && !selectedFilters.is_verify) {
			return prevFilter;
		}

		if (selectedFilters.is_section) {
			// console.log('section')
			const filtered_item = prevFilter.filter((el) => {
				return el.is_section === selectedFilters.is_section;
			});
			if (filtered_item.length) {
				filtered_list.push(...filtered_item);
			}
		}

		if (selectedFilters.is_verify) {
			// console.log('verify')
			const filtered_item = prevFilter.filter((el) => {
				return el.is_verify === selectedFilters.is_verify;
			});
			if (filtered_item.length) {
				filtered_list.push(...filtered_item);
			}
		}
		//  else {
		// 	const filtered_item = prevFilter.filter((el) => {
		// 		return (
		// 			el.is_section === selectedFilters.is_section &&
		// 			el.is_verify === selectedFilters.is_verify
		// 		);
		// 	});
		// 	if (filtered_item.length) {
		// 		filtered_list.push(...filtered_item);
		// 	}
		// }

		return filtered_list;
	};

	const files_filter_list = (prevFilter, selectedFilters) => {
		const filtered_list = [];
		if (
			!selectedFilters?.has_audio &&
			!selectedFilters?.has_image &&
			!selectedFilters?.has_video
		) {
			return prevFilter;
		}
		if (
			selectedFilters.has_image &&
			!selectedFilters?.has_audio &&
			!selectedFilters?.has_video
		) {
			// console.log('has image');
			const filtered_item = prevFilter.filter((el) => {
				return el.has_files?.image === selectedFilters.has_image;
			});
			if (filtered_item.length) {
				filtered_list.push(...filtered_item);
			}
		}
		if (
			selectedFilters.has_audio &&
			!selectedFilters?.has_image &&
			!selectedFilters?.has_video
		) {
			// console.log('has audio');
			const filtered_item = prevFilter.filter((el) => {
				return el.has_files?.audio === selectedFilters.has_audio;
			});
			if (filtered_item.length) {
				filtered_list.push(...filtered_item);
			}
		}
		if (
			selectedFilters.has_video &&
			!selectedFilters?.has_audio &&
			!selectedFilters?.has_image
		) {
			// console.log('has video');
			const filtered_item = prevFilter.filter((el) => {
				return el.has_files?.video === selectedFilters.has_video;
			});
			if (filtered_item.length) {
				filtered_list.push(...filtered_item);
			}
		}
		if (
			selectedFilters.has_image &&
			selectedFilters.has_audio &&
			!selectedFilters.has_video
		) {
			const filtered_item = prevFilter.filter((el) => {
				return (
					el.has_files?.image === selectedFilters.has_image &&
					el.has_files?.audio === selectedFilters.has_audio
				);
			});
			if (filtered_item.length) {
				filtered_list.push(...filtered_item);
			}
		}
		if (
			selectedFilters.has_image &&
			selectedFilters.has_video &&
			!selectedFilters.has_audio
		) {
			// console.log('has video and image');
			const filtered_item = prevFilter.filter((el) => {
				return (
					el.has_files?.image === selectedFilters.has_image &&
					el.has_files?.video === selectedFilters.has_video
				);
			});
			if (filtered_item.length) {
				filtered_list.push(...filtered_item);
			}
		}
		if (
			selectedFilters.has_audio &&
			selectedFilters.has_video &&
			!selectedFilters.has_image
		) {
			// console.log('has video and audio');
			const filtered_item = prevFilter.filter((el) => {
				return (
					el.has_files?.audio === selectedFilters.has_audio &&
					el.has_files?.video === selectedFilters.has_video
				);
			});
			if (filtered_item.length) {
				filtered_list.push(...filtered_item);
			}
		}
		if (
			selectedFilters.has_audio &&
			selectedFilters.has_video &&
			selectedFilters.has_image
		) {
			const filtered_item = prevFilter.filter((el) => {
				return (
					el.has_files?.image === selectedFilters.has_image &&
					el.has_files?.video === selectedFilters.has_video &&
					el.has_files?.audio === selectedFilters.has_audio
				);
			});
			if (filtered_item.length) {
				filtered_list.push(...filtered_item);
			}
		}

		return filtered_list;
	};

	const category_filter_list = (prevFilter, selectedFilters) => {
		const filteredList = [];
		if (!selectedFilters.categories.length) {
			return prevFilter;
		} else {
			const filtered_item = prevFilter.filter((item) => {
				const filtered_cat = item.categories.filter((cat) => {
					return selectedFilters?.categories.includes(cat.title);
				});
				return filtered_cat.length > 0;
			});
			if (filtered_item.length) {
				filteredList.push(...filtered_item);
			}
		}
		return filteredList;
	};

	const applyFilters = useCallback(() => {
		// Start chain of rsponsibility design pattern:
		// 1- check that if we have any filter on price rangeSlider
		const date_filter_result = date_filter_list(selectedFilters);

		// 2- check Story Type filter
		const type_filter_result = type_filter_list(
			date_filter_result,
			selectedFilters
		);

		// Then we use previous step filter and pass it to second filter section
		const files_filter_result = files_filter_list(
			type_filter_result,
			selectedFilters
		);

		// Then we use previous step result and pass it to last filter part
		const category_filter_result = category_filter_list(
			files_filter_result,
			selectedFilters
		);

		dispatch(setFilterMarkers(category_filter_result));
	}, [dispatch, selectedFilters, date_filter_list]);

	const onChangeDate = (range, timestamp) => {
		setState((prev) => ({
			...prev,
			dateRange: {
				...prev.dateRange,
				[range]: timestamp
			}
		}));
	};

	const onFilterChange = () => {
		// applyFilters();
	};

	const onResetFilter = () => {
		dispatch(resetFilters());
	};

	// useEffect(() => {
	// 	if (state.dateRange.from || state.dateRange.to) applyFilters();
	// }, [applyFilters, state.dateRange.from, state.dateRange.to, selectedFilters]);

	useEffect(() => {
		if (!isOpen) {
			return null;
		}
		getFilterData();
		createFilter();
	}, [getFilterData, createFilter, isOpen]);

	return (
		<ModalBox size={size} onClose={onClose} isOpen={isOpen}>
			<header className={styles.header}>
				<h3 className={styles.headerTitle}>
					فیلتر ها{' '}
					{/* <span
						className={
							styles.headerCount
						}>{`(${state.count} مورد)`}</span> */}
				</h3>
				<Button className={styles.resetFilter} onClick={onResetFilter}>
					حذف فیلتر ها
				</Button>
			</header>
			<div className={styles.body}>
				<FilterBoxStoryDate onChange={onChangeDate} />
				<FilterBoxStoryType onChange={onFilterChange} />
				<FilterBoxStoryFile onChange={onFilterChange} />
				<FilterBoxStoryCategory onChange={onFilterChange} />
			</div>
		</ModalBox>
	);
};
